/** Quick client-side feedback; the server remains the authority on valid addresses. */
export const isUsableEmailAddress = value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || "").trim());